var $958bf8e7ba34fdc3$exports = {};
$958bf8e7ba34fdc3$exports = {
    "valid": `Der\u{12B}gs`
};


export {$958bf8e7ba34fdc3$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
